// 易校园
import defaultConfig from './default'
import _ from "lodash";

module.exports = _.merge({}, defaultConfig, {
	name: '易校园',
	match() {
		let userAgent = navigator.userAgent
		return userAgent.match(`yunmaapp.NET`)
	},
})



// WEBPACK FOOTER //
// ./src/mods/channels/yixiaoyuan.js